function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 35
}, /*#__PURE__*/React.createElement("g", {
  stroke: "rgba(255,255,255,0.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 110,
  r: 110,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 110,
  r: 92.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M215.182 43l-97.406 97.406L73.5 96.131",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239.931,
    height: 220,
    viewBox: "0 0 239.931 220"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMzkuOTMxIiBoZWlnaHQ9IjIyMCIgdmlld0JveD0iMCAwIDIzOS45MzEgMjIwIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE2MyAtNDY4NSkiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNjMgNDY4NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjUpIiBzdHJva2Utd2lkdGg9IjM1Ij48Y2lyY2xlIGN4PSIxMTAiIGN5PSIxMTAiIHI9IjExMCIgc3Ryb2tlPSJub25lIi8+PGNpcmNsZSBjeD0iMTEwIiBjeT0iMTEwIiByPSI5Mi41IiBmaWxsPSJub25lIi8+PC9nPjxwYXRoIGQ9Ik0xNDUuNjgyLDYsNDguMjc2LDEwMy40MDYsNCw1OS4xMzEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMzIuNSA0NzIyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMzUiLz48L2c+PC9zdmc+";
export { SvgSuccess as ReactComponent };